import { TFunction, TOptions } from 'i18next'
import { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

// Cast identity to TFunction<'translation', undefined> to satisfy TypeScript
const identity: TFunction<'translation', undefined> = ((v: any) => v) as TFunction

export const useSafetyTranslation = () => {
  const { t } = useTranslation()

  const safetyTranslation = useMemo<TFunction<'translation', undefined>>(() => {
    return t && typeof t === 'function' ? t : identity
  }, [t])

  const safeT = useCallback(
    (key: string | TemplateStringsArray, options?: TOptions) => {
      try {
        return decodeURIComponent(safetyTranslation(key as string, options))
      } catch (e) {
        return safetyTranslation(key as string)
      }
    },
    [safetyTranslation]
  )

  return safeT
}
